import get from 'lodash/get'
import { PUSH_AD, UPDATE_ADS_LAST_REFRESH_TIME } from '../actionTypes'
import isFunction from 'lodash/isFunction'
export function pushAd(ad) {
  return {
    type: PUSH_AD,
    ad,
  }
}

export function updateLastRefreshTime() {
  return {
    type: UPDATE_ADS_LAST_REFRESH_TIME,
  }
}

export function resetAllAds() {
  return (dispatch, getState) => {
    const now = new Date()
    const adsLastRefreshedAt = get(getState(), 'ads.adsLastRefreshedAt', now)
    const secondsSinceAdsRefreshed =
      (now.getTime() - adsLastRefreshedAt.getTime()) / 1000

    // only reset ads if > 30 seconds elapsed since last ad update time
    if (secondsSinceAdsRefreshed < 30) {
      return
    }

    // https://developers.google.com/doubleclick-gpt/reference#googletag.PubAdsService_refresh
    // check for nullness (adblockers)
    if (window.googletag && window.googletag.pubads) {
      const adService = window.googletag.pubads()

      if (adService && isFunction(adService.refresh)) {
        // Wait until browser is idle before refreshing ads
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => adService.refresh())
        } else {
          adService.refresh()
        }
      }
    }
    dispatch(updateLastRefreshTime())
  }
}
